import React from 'react';
import { Mail, Instagram, MessageSquare } from 'lucide-react';
import { motion } from 'framer-motion';

export default function ContactPage() {
  const contactMethods = [
    {
      icon: Mail,
      title: "אימייל",
      value: "snailsradio@gmail.com",
      href: "mailto:snailsradio@gmail.com",
      color: "#784BCB"
    },
    {
      icon: Instagram,
      title: "אינסטגרם",
      value: "@snailsradio",
      href: "https://instagram.com/snailsradio",
      color: "#E15E92"
    }
  ];

  return (
    <div className="max-w-5xl mx-auto py-8 px-4">
      {/* Header */}
      <motion.div
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="text-center mb-12"
      >
        <h1 className="text-3xl md:text-4xl font-bold mb-4 text-[#393737]">צור קשר</h1>
        <p className="content-text text-[#393737] max-w-2xl mx-auto">
          אנחנו תמיד שמחים לשמוע מהמאזינים! שלחו לנו הודעה, הצעה לשיתוף פעולה או רעיון לתוכנית חדשה.
        </p>
      </motion.div>

      {/* Contact Methods */}
      <motion.div 
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12"
      >
        {contactMethods.map((method, index) => (
          <motion.a
            key={method.title}
            href={method.href}
            target={method.href.startsWith('http') ? '_blank' : undefined}
            rel={method.href.startsWith('http') ? 'noopener noreferrer' : undefined}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ scale: 1.02, y: -5 }}
            className="bg-white rounded-lg shadow-md p-6 flex items-center gap-4 border-t-4"
            style={{ borderColor: method.color }}
          >
            <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: `${method.color}20` }}>
              <method.icon className="w-6 h-6" style={{ color: method.color }} />
            </div>
            <div>
              <h3 className="font-bold text-lg text-[#393737] app-title">{method.title}</h3>
              <p className="content-text text-[#393737]/70" style={{ color: method.color }}>{method.value}</p>
            </div>
          </motion.a>
        ))}
      </motion.div>

      {/* Form Section */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden mb-12">
        {/* Form Header */}
        <div className="bg-gradient-to-r from-[#784BCB] to-[#E15E92] p-6 text-white">
          <div className="flex items-center gap-4">
            <div className="bg-white/20 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
              <MessageSquare className="w-5 h-5 text-white" />
            </div>
            <div>
              <h2 className="text-xl font-bold app-title">טופס יצירת קשר</h2>
              <p className="readable-text text-white/80">מלאו את הפרטים ונחזור אליכם בהקדם</p>
            </div>
          </div>
        </div>

        {/* Google Form Integration */}
        <div className="p-4">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSdhiv2vbReQLuEQKfeOcPPqQU_MXsB3WCmDDS5GJZaCFv4gXw/viewform?embedded=true"
            className="w-full h-[1365px] bg-transparent"
            frameBorder="0"
            marginHeight="0" 
            marginWidth="0"
            title="Contact Form"
          >
            Loading...
          </iframe>
        </div>
      </div>
    </div>
  );
} 